import { createGlobalStyle } from "styled-components";

const JsCmFormStyles = createGlobalStyle`
    /*  No, YOU are awesome!! */
    .js-cm-form {
        margin: 0 auto; 
        max-width: 48rem;
        label {
            display: block;
        }
        input, 
        textarea {
            appearance: none;
            box-sizing: border-box;
            background-color: transparent;
            background-image: none;
            border: none;
            border-radius: 0;
            box-shadow: none;
            color: var(--form-input-color, black);
            display: block;
            font-family: inherit;
            font-size: inherit;
            font-weight: inherit;
            height: auto;
            line-height: 1.3;
            padding: 1rem 0 .75rem 0;
            margin: 0 0 .5rem 0;
            outline: none;
            text-transform: none;
            width: 100%;
            overflow: hidden;
            border-bottom: var(--form-input-border-width, 2px) solid var(--form-input-border-color, gray);
        }
        button {
            background-color: var(--color-gray-60, black);
            border-radius: 0;
            border-width: 2px;
            border-style: solid;
            border-color: var(--color-gray-60, black);
            color: white;
            cursor: pointer;
            display: inline-flex;
            font-size: var(--text-small, 13px);
            font-weight: bold;
            letter-spacing: .075em;
            line-height: 1.25;
            margin-bottom: .5rem;
            min-width: 10.5rem;
            justify-content: center;
            overflow: hidden;
            padding: .75em 1.5em;
            position: relative;
            user-select: none;
            text-decoration: none;
            text-transform: uppercase;
            transition: all .4s;
            z-index: 0;
            &:focus {
                outline: none;
            }
            &:before {
                content: "";
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 50%;
                z-index: -1;
                transform: translateX(-50%);
                max-width: 0;
                transition: max-width .2s;
                background-color: var(--color-black, black);
            }
            &:hover {
                box-shadow: var(--shadow-inner);
                border-color: var(--color-black, black);
                &:before {
                    max-width: 100%;
                }
            }
        }
    }
`;

export default JsCmFormStyles;